import { render, staticRenderFns } from "./claas.vue?vue&type=template&id=6439ba40&"
import script from "./claas.vue?vue&type=script&lang=js&"
export * from "./claas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports